/* eslint-disable @typescript-eslint/camelcase */
import formatDateWithoutTime from "@/app/infrastructures/misc/common-library/FormatDateWithoutTime";
import { BaseRatesData } from "./BaseRates";
import { Pagination } from "./Pagination";
import convertPhoneNumber from "@/app/infrastructures/misc/common-library/ConvertPhoneNumber";
import { OptionsClass } from "./MainApp";
import { formatDate, formatDateNormal } from '@/app/infrastructures/misc/Utils';

export class ClientManagementEntities {
  pagination: Pagination;
  data: ClientManagementData[];
  constructor(pagination: Pagination, data: ClientManagementData[]) {
    this.pagination = pagination;
    this.data = data;
  }
}

export class ClientManagementData {
  clientId = 0;
  clientCompanyName = "";
  clientAlias = "";
  clientCode = "";
  rateVersionStartDate = "";
  rateVersionEndDate = "";
  rateVersionStatus = "";
  rateVersionStatusRenewal = "";
  clientType = "";
  clientStatus = "";
  constructor(fields?: Partial<ClientManagementData>) {
    Object.assign(this, fields);
  }
}

export class ClientCurrentRate {
  clientCustomRateId = 0;
  clientStatusCustomRate = "";
  clientRateversionStartDate = "";
  clientRateVersionEndDate = "";
  clientStatusUpdatedAt = "";
  clientStatusUpdatedBy = "";
  clientStatusUpdatedReason = "";
  clientVersionBaseRate = "";
  clientDiscountBaseRate: any;
  clientFileNameBaseRate = "";
  clientFileBaseRate = "";
  clientVersionCustomRate = "";
  clientFileNameCustomRate = "";
  clientFileCustomRate = "";
  clientErrorNameCustomRate = "";
  clientErrorFileCustomRate = "";
  isBaseRate = false;
  isCustomRate = false;
  isCombine = false;
  clientRateVersionCustom3lc = "";
  clientRatePriceType = "";
  clientRateInsuranceType = "";
  clientRateInsuranceValuePercentage = 0;
  clientRateUpdatedAt = "";

  constructor(fields?: Partial<ClientCurrentRate>) {
    Object.assign(this, fields);
  }
}
export class ClientRenewalRate {
  clientCustomRateId = 0;
  clientStatusCustomRate = "";
  clientRateversionStartDate = "";
  clientRateVersionEndDate = "";
  clientStatusUpdatedAt = "";
  clientStatusUpdatedBy = "";
  clientStatusUpdatedReason = "";
  clientVersionBaseRate = "";
  clientDiscountBaseRate: any;
  clientFileNameBaseRate = "";
  clientFileBaseRate = "";
  clientVersionCustomRate = "";
  clientFileNameCustomRate = "";
  clientFileCustomRate = "";
  clientErrorNameCustomRate = "";
  clientErrorFileCustomRate = "";
  clientRateVersionCustom3lc = "";
  clientRatePriceType = "";
  clientRateInsuranceType = "";
  clientRateInsuranceValuePercentage = 0;
  clientRateUpdatedAt = "";

  constructor(fields?: Partial<ClientRenewalRate>) {
    Object.assign(this, fields);
  }
}
export class ClientLocation {
  id = 0;
  code = "";
  name = "";
  cityCode? = "";

  constructor(fields?: Partial<ClientLocation>) {
    Object.assign(this, fields);
  }
}
export class ClientCod {
  clientCodName = "";
  clientCodAddress = "";
  clientCodDistrict: any = "";
  clientCodCity = "";
  clientCodPhone = "";
  clientCodCommission = "";
  clientCodCommissionPercentage = "";

  constructor(fields?: Partial<ClientCod>) {
    Object.assign(this, fields);
  }
}
export class ClientCodAsDefault {
  defaultCodName = "";
  defaultCodAddress = "";
  defaultCodDistrict: any = "";
  defaultCodCity = "";
  defaultCodPhone = "";

  constructor(fields?: Partial<ClientCodAsDefault>) {
    Object.assign(this, fields);
  }
}

export class ClientBilling {
  noWhatsApp = "";
  billingSchedule = "";
  timeRangePayment = "";
  email: Array<string> = [];
  startDate = "";
  endDate = "";
  attachment = "";
  attachmentUrl = "";
  pksAttachment = "";
  pksAttachmentUrl = "";
  constructor(fields?: Partial<ClientBilling>) {
    Object.assign(this, fields);
  }

  get formattedStartDate() {
    return formatDateWithoutTime(this.startDate);
  }
  get formattedEndDate() {
    return formatDateWithoutTime(this.endDate);
  }
  get formattedEmail() {
    return this.email.join(", ");
  }
  get formattedWhatsappNumber() {
    return `+${convertPhoneNumber(this.noWhatsApp)}`;
  }

  get fileNameAttachment() {
    return this.attachmentUrl.split("/").pop();
  }

  get fileNamePKSAttachment() {
    return this.pksAttachmentUrl.split("/").pop();
  }
}
export class ClientTax {
  NIK = "";
  NIKName = "";
  NIKAddress = "";
  isTaxPayer = false;
  taxNumber = "";
  taxPayerName = "";
  taxPayerAddress = "";
  transactionCode = "05 Besaran Tertentu";
  taxAttachment = "";
  taxAttachmentUrl = "";
  isEfakturWithNik = false;
  clientNikId = "";
  clientNikName = "";
  clientNikAddress = "";
  constructor(fields?: Partial<ClientTax>) {
    Object.assign(this, fields);
  }

  get fileNameTaxAttachment() {
    return this.taxAttachmentUrl.split("/").pop();
  }
}

export class BankDetail {
  bankLabel = "";
  bankName = "";
  accountNo = "";
  accountName = "";
  email = "";
  logo = "";
  constructor(fields?: Partial<BankDetail>) {
    Object.assign(this, fields);
  }
}

export class ClientDetailUpdateItem {
  currentVal = "";
  prevVal = "";
  updatedById = 0;
  updatedByName = "";
  updatedAt = 0;

  constructor(fields?: Partial<ClientDetailUpdateItem>) {
    Object.assign(this, fields);
  }
}

export class ClientDetailUpdate {
  clientInfo: Record<string, ClientDetailUpdateItem> = {}
  taxInfo: Record<string, ClientDetailUpdateItem> = {}
  billingInfo: Record<string, ClientDetailUpdateItem> = {}
  contractInfo: Record<string, ClientDetailUpdateItem> = {}
  bank: Record<string, ClientDetailUpdateItem> = {}
  bankSettlement: Record<string, ClientDetailUpdateItem> = {}
  contactInfo: Record<string, ClientDetailUpdateItem> = {}
  payment: Record<string, ClientDetailUpdateItem> = {}
  returnConfigurationInfo: Record<string, ClientDetailUpdateItem> = {}
  returnInfo: Record<string, ClientDetailUpdateItem> = {}
  codInfo: Record<string, ClientDetailUpdateItem> = {}
  clientParentInfo: Record<string, ClientDetailUpdateItem> = {}

  constructor(fields?: Partial<ClientDetailUpdate>) {
    Object.assign(this, fields);
  }

  get newestUpdatedField() {
    const {
      taxInfo,
      contractInfo,
      clientInfo,
      billingInfo,
      bank,
      contactInfo,
      bankSettlement,
      payment,
      returnConfigurationInfo,
      clientParentInfo,
      codInfo,
      returnInfo
    } = this; // destruct to make sure that we only take this property
    const clientDetail = {
      ...taxInfo,
      ...contractInfo,
      ...clientInfo,
      ...bank,
      ...billingInfo,
      ...contactInfo,
      ...bankSettlement,
      ...payment,
      ...returnInfo,
      ...returnConfigurationInfo,
      ...codInfo,
      ...clientParentInfo

    } // combine to object

    const clientFields = this.sortNewestByUpdatedAt(clientDetail);
    return clientFields
  }

  get newestUpdatedClientInfo() {
    return this.sortNewestByUpdatedAt(this.clientInfo);
  }

  get newestUpdatedTaxInfo() {
    return this.sortNewestByUpdatedAt(this.taxInfo);
  }

  get newestUpdatedContractInfo() {
    return this.sortNewestByUpdatedAt(this.contractInfo);
  }

  get newestUpdatedBillingInfo() {
    return this.sortNewestByUpdatedAt(this.billingInfo);
  }

  get newestUpdatedBank() {
    return this.sortNewestByUpdatedAt(this.bank);
  }

  get newestUpdatedBankSettlement() {
    return this.sortNewestByUpdatedAt(this.bankSettlement);
  }

  get newestUpdatedContactInfo() {
    return this.sortNewestByUpdatedAt(this.contactInfo);
  }

  get newestUpdatedPayment() {
    return this.sortNewestByUpdatedAt(this.payment);
  }

  get newestUpdatedReturnConfigurationInfo() {
    return this.sortNewestByUpdatedAt(this.returnConfigurationInfo)
  }

  get newestUpdatedReturnInfo() {
    return this.sortNewestByUpdatedAt(this.returnInfo)
  }

  get newestUpdatedCodInfo() {
    return this.sortNewestByUpdatedAt(this.codInfo)
  }

  get newestUpdatedClientParentInfo() {
    return this.sortNewestByUpdatedAt(this.clientParentInfo)
  }

  private sortNewestByUpdatedAt(data: Record<string, ClientDetailUpdateItem>) {
    return Object.values(data).filter(value => {
      return value.updatedById // make sure we filter updated only field
    }).sort((val1, val2) => {
      return val2.updatedAt - val1.updatedAt // compare newest date
    }).map(value => {
      return {
        ...value,
        updatedAt: formatDate(new Date(value.updatedAt)) // map format date
      }
    })
  }
}

export class DetailClientManagement {
  id = 0;
  clientName = "";
  clientAlias = "";
  clientType = "";
  clientBalance = 0;
  clientCategory = "";
  clientIsBanned = false;
  clientBannedReason = "";
  clientAccountName = "";
  clientAccountNumber = "";
  clientBankName = "";
  clientBeneficiaryEmail = "";
  clientContactEmail = "";
  clientContactJobTitle = "";
  clientContactName = "";
  clientContactPhone = "";
  clientIsCod = false;
  clientIsDfod = false;
  clientIsDo = false;
  clientParentId = 0;
  clientParentCode = "";
  clientParentName = "";
  clientPartnerCommissionAmount = "";
  clientPartnerCommissionAmountPercentage = "";
  clientPartnerId = 0;
  clientPartnerName = "";
  clientPartnerQuantifierCommission = "";
  clientPartnerNumeratorCommission = "";
  clientCode = "";
  clientElexysCode = "";
  clientPhone = "";
  clientEmail = "";
  clientTaxNumber = "";
  clientStatus = "";
  clientAddress = "";
  clientDistrict = new ClientLocation();
  clientCity = new ClientLocation();
  clientStatusUpdatedAt = "";
  clientStatusUpdatedBy = "";
  clientStatusUpdatedReason = "";
  clientIsCustomRate = false;
  clientIsRenewalCustomRate = false;
  clientCreatedAt = "";
  clientUpdatedAt = "";
  clientCreatedBy = "";
  clientUpdatedBy = "";
  clientCurrentRate = new ClientCurrentRate();
  clientCodReject = new ClientCod();
  clientCodRejectAsDefault = new ClientCodAsDefault();
  dataProcessed = 0;
  totalData = 0;
  clientRenewalRate = new ClientRenewalRate();
  clientOdooId = 0;
  clientCompanySize = "";
  clientTax = new ClientTax();
  clientBilling = new ClientBilling();
  bankDetail = new BankDetail();
  bankSettlement = new BankDetail();
  clientPadFee = 0;
  clientPadFeePercentage = "";
  rateActiveDate = "";
  clientPaymentMethod = new OptionsClass();
  clientCodConfigAmount = new OptionsClass();
  clientCodShipmentDiscount = "";
  clientCodShipmentDiscountPercentage = "";
  clientBranchDoPaymentType = "";
  isReturnConfig = false;
  returnConfigLimit = 0;
  returnConfigReasonIds = "";
  priceType = "";
  rateVersionCustom3lc = "";
  insuranceType = "";
  insuranceValuePercentage = 0;
  dataProcessedCurrent = 0;
  dataProcessedRenewal = 0;
  totalDataCurrent = 0;
  totalDataRenewal = 0;
  clientFreeze = false;
  clientIsNeedAssessment = false;
  clientParentIsNeedAssessment = false;
  isFtz = "no";
  isEfakturWithNik = false;
  detailUpdate = new ClientDetailUpdate();

  constructor(fields?: Partial<DetailClientManagement>) {
    Object.assign(this, fields);
    if (!fields?.clientPaymentMethod) {
      this.clientPaymentMethod = new OptionsClass();
    }
    if (!fields?.clientCodConfigAmount) {
      this.clientCodConfigAmount = new OptionsClass();
    }
    if (!fields?.clientCodShipmentDiscount) {
      this.clientCodShipmentDiscount = "0";
    } else {
      this.clientCodShipmentDiscount = String(
        fields?.clientCodShipmentDiscount
      );
    }
  }

  get rateUpdatedAt() {
    if (this.clientCurrentRate.clientStatusUpdatedAt) {
      return formatDate(this.clientCurrentRate.clientStatusUpdatedAt);
    }

    return formatDate(this.clientCreatedAt);
  }

  get rateUpdatedBy() {
    if (this.clientCurrentRate.clientStatusUpdatedBy) {
      return this.clientCurrentRate.clientStatusUpdatedBy;
    }

    return this.clientCreatedBy;
  }

  get newestUpdatedDetail() {
    const clientField = this.detailUpdate.newestUpdatedField.length
      ? this.detailUpdate.newestUpdatedField[0]
      : new ClientDetailUpdateItem({ // use client updated if there is no data in client_meta.update_detail
        updatedByName: this.clientUpdatedBy,
        updatedAt: formatDate(this.clientUpdatedAt),
        updatedById: 0,
        prevVal: "",
        currentVal: ""
      })

    return clientField
  }

  formattedStartDateBilling() {
    return formatDateWithoutTime(this.clientBilling.startDate);
  }
  formattedEndDateBilling() {
    return formatDateWithoutTime(this.clientBilling.endDate);
  }
}

export class File {
  file = "";
  name = "";
  constructor(fields?: Partial<File>) {
    Object.assign(this, fields);
  }
}

export class DetailClientForm {
  id = 0;
  companyName = "";
  email = "";
  phone = "";
  address = "";
  taxNumber = "";
  versionBasic: string | undefined | BaseRatesData = "";
  isCustomRate = "";
  currentDiscount = "";
  discount: any = "";
  versionName = "";
  archiveFile = "";
  rateVersionId = 0;
  fileCustomRate = new File();
  rateActiveDate = "";
  constructor(fields?: Partial<DetailClientForm>) {
    Object.assign(this, fields);
  }
}
